// extracted by mini-css-extract-plugin
export var chevron = "_l2-2";
export var chevronRotated = "_l2-3";
export var header = "_l2-1";
export var section = "_l2-0";